import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { WidgetApiService } from 'src/app/api/bizzmine/widget/widget-api.service';
import { WidgetData } from 'src/app/api/bizzmine/dashboard/dashboard-api.service';

export const widgetWorkspaceItemResolver: ResolveFn<WidgetData | undefined> = (route, state) => {
  const workspaceId = route.params['workspaceItemId'];
  if(workspaceId == '0') return;
  return inject(WidgetApiService).getWidgetByWorkspaceItemId(
    route.params['workspaceItemId']
  );
};
